module.exports = {
    initial: 'initial',
    ready: 'ready',
    waiting: 'waiting',
    disposed: 'disposed'
};


/** WEBPACK FOOTER **
 ** ./src/constants/ui-state.js
 **/